import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ParallaxSection } from './ParallaxSection';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const TESTIMONIAL_BG = 'https://images.unsplash.com/photo-1529156069898-49953eb1f5bc?w=1920&q=80';
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [{
    quote: "Prime Nation's free phone and tablet services have been an absolute game-changer for me. As a student on a tight budget, I couldn't afford expensive devices or hefty monthly bills. The service is reliable, the devices are top-notch, and best of all, it's completely free. I highly recommend Prime Nation to anyone looking for quality tech without breaking the bank.",
    name: 'SARAH W.',
    role: 'PRIME NATION MEMBER'
  }, {
    quote: 'Getting my home internet set up through Prime Nation was the easiest process ever. The staff treated me with such respect and made sure I understood everything. Now my kids can do their homework online without us worrying about the monthly bill.',
    name: 'MARCUS T.',
    role: 'PRIME NATION MEMBER'
  }];
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <ParallaxSection bgImage={TESTIMONIAL_BG} overlayOpacity={0.75} className="py-20 md:py-32" data-id="element-228">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-cream border-2 border-brand-gold rounded-2xl p-8 md:p-12 max-w-[800px] w-full relative shadow-2xl" data-id="element-230">
          {/* Large Quote Mark */}
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-brand-black w-16 h-16 rounded-full flex items-center justify-center border-2 border-brand-gold" data-id="element-231">
            <span className="text-brand-gold font-serif text-6xl leading-none pt-4" data-id="element-232">
              "
            </span>
          </div>

          <div className="relative min-h-[250px] md:min-h-[200px] flex flex-col justify-center mt-4" data-id="element-233">
            <AnimatePresence mode="wait" data-id="element-234">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="text-center" data-id="element-235">
                <p className="font-serif text-xl md:text-2xl text-brand-charcoal leading-relaxed mb-8" data-id="element-236">
                  {testimonials[currentIndex].quote}
                </p>

                <div className="flex flex-col items-center justify-center" data-id="element-237">
                  <div className="w-12 h-1 bg-brand-gold mb-4" data-id="element-238"></div>
                  <p className="font-bold text-brand-black tracking-wider uppercase" data-id="element-239">
                    {testimonials[currentIndex].name}
                  </p>
                  <p className="text-sm text-brand-charcoal/60 font-medium mt-1" data-id="element-240">
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Carousel Controls */}
          {testimonials.length > 1 && <div className="flex justify-center gap-4 mt-8" data-id="element-241">
              <button onClick={prev} className="w-10 h-10 rounded-full border border-brand-gold/50 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" aria-label="Previous testimonial" data-id="element-242">
                <ChevronLeft size={20} data-id="element-243" />
              </button>
              <button onClick={next} className="w-10 h-10 rounded-full border border-brand-gold/50 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" aria-label="Next testimonial" data-id="element-244">
                <ChevronRight size={20} data-id="element-245" />
              </button>
            </div>}
        </motion.div>
      </div>
    </ParallaxSection>;
}